import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

// redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import ReaderBonusOverview from './readerBonusOverview';
import GetMoreReadersMessage from '../../components/standard-messages/getMoreReadersMessage';
import UnlockSignupBonusMessage from '../../components/standard-messages/unlockSignupBonusMessage';

import {
  updateWritingList
} from '../../modules/book';

import {
  authUtil,
  uxAnalyticsUtil
} from '../../utils';

export class ReaderBonus extends Component {
  componentDidMount() {
    const { history } = this.props;
    uxAnalyticsUtil.trackPageView(history.location.pathname);
    this.fetchWritingList();
  }

  fetchWritingList = async () => {
    const { activeAccount, userProfile } = this.props;
    const idToken = await authUtil.getFreshIdToken();
    let accountId = activeAccount && activeAccount._id;
    if (accountId === undefined) {
      accountId = userProfile?.account?._id;
    }
    this.props.updateWritingList({
      idToken,
      accountId
    });
  }

  render() {
    const { userProfile, user, writing } = this.props;
    if (user !== undefined && userProfile !== undefined) {
      return (
        <div style={{ display: 'grid', gap: '1rem' }}>
          <GetMoreReadersMessage user={user} userProfile={userProfile} />
          {userProfile.wasReferred && !userProfile.signupReferralBonus && (
            <UnlockSignupBonusMessage key='unlock-bonus' userProfile={userProfile} user={user} writing={writing} />
          )}
          <ReaderBonusOverview />
        </div>
      );
    }
    return null;
  }
}

// redux stuff
const mapStateToProps = state => ({
  activeAccount: state.account.activeAccount,
  user: state.user.user,
  idToken: state.user.idToken,
  userProfile: state.user.userProfile,
  writing: state.book.writing
});

const mapDispatchToProps = dispatch => bindActionCreators({
  updateWritingList
}, dispatch);

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(ReaderBonus));
